import React from 'react';
import { Send } from '@mui/icons-material';

const MessageInput = ({ 
  newMessage, 
  handleInputChange, 
  sendMessage 
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      sendMessage(e);
    }
  };

  return (
    <div className="message-input-container">
      <form className="message-input-form" onSubmit={sendMessage}>
        <div className="input-wrapper-messenger">
          <input
            type="text"
            value={newMessage}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            placeholder="Type a message..."
            className="message-input-messenger"
            maxLength={1000}
          />
          
          <button 
            type="submit" 
            className="send-btn-messenger"
            title="Send message"
            disabled={!newMessage.trim()}
          >
            <Send />
          </button>
        </div>
      </form>
    </div>
  );
};

export default MessageInput;